import { useMemo } from "react";
import { useSelector } from "react-redux";

import useDeviceType from "../hook/useDeviceType";

export default function ShouldHideMenu() {
  const deviceType = useDeviceType();
  const isMenuOpen = useSelector((state) => state.isMenuOpen);
  return useMemo(() => {
    return deviceType === "PC" && !isMenuOpen;
  }, [isMenuOpen, deviceType]);
}
